import auth from './authSlice';
import storeSlice from './storeSlice';
const reducer = { auth, storeSlice };

export default reducer;
